// CheckoutForm.js
import React, { useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { stripeCharges } from "../../../actions/emActions";

const CheckoutForm = ({ price, invoiceData }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [billingDetails, setBillingDetails] = useState({
    email: "",
    phone: "",
    name: "",
  });
  const [paymentDetails, setpaymentDetails] = useState();
  //   {
  //     response: {
  //       data: {
  //         status: 200,
  //       },
  //     },
  //   }
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of each
    // type of element.

    // Use your card Element with other Stripe.js APIs
    const payload = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
      billing_details: billingDetails,
    });

    if (payload.error) {
      console.error(payload.error);
    } else {
      const data = {
        source: payload["paymentMethod"].id,
        amount: price,
        currency: "PKR",
        invoiceIds: invoiceData.filter((item) => item.checked === true).map((item) => item.id).join(","),
      };
      stripeCharges(data).then((res) => {
        setpaymentDetails(res);
        debugger;
      });
      console.log("Stripe Data", payload);
      console.log("Data", data);
    }
  };

  const CARD_OPTIONS = {
    iconStyle: "solid",
    hidePostalCode: true,
    style: {
      base: {
        iconColor: "#182b49",
        color: "#122340",
        fontWeight: 500,
        fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
        fontSize: "16px",
        padding: "26px",
        fontSmoothing: "antialiased",
        ":-webkit-autofill": {
          color: "#fce883",
        },
        "::placeholder": {
          color: "#b4b9c1",
        },
        background: "#fff",
      },
      invalid: {
        iconColor: "#ff0000",
        color: "#ff0000",
      },
    },
  };

  return paymentDetails ? (
    <div className="Result">
      {/* <div className="ResultTitle" role="alert">
                <i className="fas fa-info-circle"></i> Payment Info
            </div> */}
      {paymentDetails?.data?.status === "succeeded" ? (
        <div className="ResultMessage text-center">
          <i className="text-success fas fa-check-circle fa-3x"></i>
          <br />
          <label
            style={{ fontSize: 18 }}
            className="text-success font-weight-bold"
          >
            Payment Successful
          </label>
          <br />
          <label style={{ fontSize: 22 }} className="font-weight-bold mt-4">
            Your Invoice has been paid!
          </label>
          <br />
          <button
            className="btn btn-sm btn-primary"
            onClick={() => window.location.reload()}
          >
            Continue
          </button>
        </div>
      ) : paymentDetails?.data?.status === "requires_action" ? (
        <div className="twoDMessage text-center">
          <div className="iconTwo">
            <i className="fas fa-info-circle fa-3x"></i>
          </div>
          <br />
          <label
            style={{ fontSize: 18 }}
            className="text-primary font-weight-bold mt-4"
          >
            You need to authenticate to process your payment!
          </label>
          <br />
          <i className="linkIcon fas fa-link"></i>{" "}
          <a href={paymentDetails?.data?.next_action?.redirect_to_url?.url}>
            Click here to authenticate.
          </a>
        </div>
      ) : (
        <div className="ErrorMessageStripe text-center">
          <i className="fas fa-exclamation-triangle fa-3x"></i>
          <br />
          <label
            style={{ fontSize: 18 }}
            className="text-danger font-weight-bold mt-4"
          >
            Card declined because of some error!
          </label>
          <br />
          <button
            className="btn btn-sm btn-primary"
            data-dismiss="modal"
            aria-label="Close"
          >
            Go Back
          </button>
          {/* {paymentDetails?.data?.message} */}
        </div>
      )}
      {/* <div className="ResultMessage">
                Thanks for trying Stripe Elements. No money was charged, but we
        generated a PaymentDetails: {paymentDetails}
            </div> */}
      {/* <ResetButton onClick={reset} /> */}
    </div>
  ) : (
    <div>
      <label className="font-weight-bold">
        Enter your Card Details to pay the Invoice of&nbsp;
        <span className="text-success" style={{ fontSize: 16 }}>
          PKR {Number(price).toLocaleString()}
        </span>
      </label>
      <i className="fa fa-cc-stripe fa-2x" style={{color: "#6560ec"}}/>
      <p className="text-muted" style={{ fontSize: 12 }}>
        <i className="fa fa-lock mr-1" />
        Your payment information is encrypted and securely processed through our
        trusted payment partner, <a href="https://stripe.com/" target="__blank" style={{color: "#6560ec"}}>Stripe</a>. We never store your sensitive payment details
        on our servers.
      </p>

      <form onSubmit={handleSubmit}>
        <div>
          <label className="mb-0">Name:</label>
          <input
            type="text"
            className="form-control form-control-sm"
            onChange={(e) => {
              setBillingDetails({ ...billingDetails, name: e.target.value });
            }}
          />
        </div>
        <div className="mt-2">
          <label className="mb-0">Email:</label>
          <input
            type="email"
            className="form-control form-control-sm"
            onChange={(e) => {
              setBillingDetails({ ...billingDetails, email: e.target.value });
            }}
          />
        </div>
        <div
          className=""
          style={{
            marginTop: 20,
            border: "1px solid #ced4da",
            borderRadius: "0.2rem",
            padding: 6,
          }}
        >
          <CardElement options={CARD_OPTIONS} />
        </div>
        <div className="text-center mt-5">
          <button
            type="submit"
            className="btn btn-sm btn-success w-50"
            disabled={!stripe}
          >
            Pay Now
          </button>
        </div>
      </form>
    </div>
  );
};

export default CheckoutForm;
